module.exports = __webpack_public_path__ + "img/lock.a1f70a3b.svg";